import { NEIGHBORS, VALID_POSITIONS } from "../data/board-geometry";
import type { Direction } from "../types/common";
import type { Board, CellContent } from "../types/game-state";

export function isValidPosition(pos: string): boolean {
  return VALID_POSITIONS.has(pos);
}

export function getNeighbor(pos: string, dir: Direction): string | undefined {
  return NEIGHBORS[pos]?.[dir];
}

export function getCellContent(board: Board, pos: string): CellContent {
  return board[pos] ?? null;
}

export function posToLabel(col: number, row: number): string {
  return `${String.fromCharCode(97 + col)}${row}`;
}

export function labelToColRow(label: string): { col: number; row: number } {
  return {
    col: label.charCodeAt(0) - 97,
    row: Number.parseInt(label.slice(1), 10),
  };
}

export function getLinePositions(
  from: string,
  dir: Direction,
): readonly string[] {
  const positions: string[] = [];
  let cur: string | undefined = from;
  while (cur !== undefined) {
    positions.push(cur);
    cur = NEIGHBORS[cur]?.[dir];
  }
  return positions;
}
